module.exports = __webpack_public_path__ + "img/nfts.09378365.png";